import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { PushpinOutlined } from '@ant-design/icons';
import NavCard from '../NavigationCard';
import { CONSTANTS } from '../../constants/Constants';
import './style.scss';
const LeftNavGridItem = props => {
  const {
    card,
    onFavIconClick,
    handleCardNavigation,
    modules
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "leftnav-grid-item",
    onClick: handleCardNavigation(card),
    key: card.label
  }, /*#__PURE__*/React.createElement(PushpinOutlined, {
    title: card.isPinned ? __('remove this item from favorite') : __('add this item from favorite'),
    onClick: onFavIconClick(card.appKey),
    className: card.isPinned ? 'leftnav-gitem-favpin-active' : 'leftnav-gitem-favpin'
  }), /*#__PURE__*/React.createElement(NavCard, _extends({
    modules: modules,
    card: card,
    label: card.slabel
  }, props)));
};
LeftNavGridItem.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.oneOf(['/', ...CONSTANTS.OTHER_MODULES])).isRequired,
  card: PropTypes.object.isRequired,
  handleCardNavigation: PropTypes.func.isRequired,
  onFavIconClick: PropTypes.func.isRequired
};
export default LeftNavGridItem;